module.exports = __webpack_public_path__ + "img/27.bd51f8cf.png";